import { useEffect } from 'react';
import { nprogress } from '@mantine/nprogress';
import { Translate } from 'react-auto-translate';
import logo from '../../images/logo.svg';
import styles from './pageLoader.module.css';

export default function PageLoader({
	fullScreen = false,
	message = fullScreen
		? 'Please wait while we set up your app...'
		: 'Loading...',
	className = '',
}) {
	useEffect(() => {
		nprogress.start();
		return () => {
			nprogress.complete();
		};
	}, []);

	return (
		<div
			className={`${styles.loader_container} ${
				fullScreen ? styles.loader_fullscreen : ''
			} ${className}`}
		>
			<div className={styles.loader_content}>
				<div className={styles.badge_wrapper}>
					<span className={styles.glow} />
					<span className={styles.track} />
					<span
						className={styles.spinner}
						role="status"
						aria-label="Loading"
					/>
					<img
						src={logo}
						alt="Quantum Ticketing Logo"
						className={styles.logo}
					/>
				</div>
				{message && (
					<p className={styles.message}>
						<Translate>{message}</Translate>
					</p>
				)}
			</div>
		</div>
	);
}
